import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { BoxQuestionnaireSelectType } from '../enums';
import { BoxQuestionnaireSelectTypeProviderService } from '../providers';

@Pipe({
  name: 'boxQuestionnaireSelectType',
})
export class BoxQuestionnaireSelectTypePipe implements PipeTransform {
  private readonly provider = inject(BoxQuestionnaireSelectTypeProviderService);

  public transform(selectType: BoxQuestionnaireSelectType): Observable<string> {
    return this.provider.labelFor(selectType);
  }
}
